// Enables any component in the application to display alert messages at the top of the page via the alert component.

import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

const TIMINGFUNC_MAP = {
	linear: t => t,
	'ease-in': t => t * t,
	'ease-out': t => t * (2 - t),
	'ease-in-out': t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t)
};


@Injectable()
export class AlertService {
	private subject = new Subject<any>();
	private keepAfterNavigationChange = false;

	constructor(private router: Router) {
		router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterNavigationChange) {
					this.keepAfterNavigationChange = false;
				} else {
					this.subject.next();
				}
			}
		});
	}

	success(message: string, keepAfterNavigationChange = false, delay?: number) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({ type: 'success', text: message });
		this.scrollToTop();
		if (delay) {
			setTimeout(() => {
				this.clear();
			}, delay);
		}
	}

	error(message: string, icon?: string, keepAfterNavigationChange = false) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({ type: 'error', text: message });
		this.scrollToTop();
	}

	getMessage(): Observable<any> {
		return this.subject.asObservable();
	}

	scrollToTop() {
		this.scrollTopSmooth(window.scrollY, 300, 'ease-in-out');
	}

	scrollTopSmooth(initY, duration = 300, timingName = 'linear') {
		const timingFunc = TIMINGFUNC_MAP[timingName];
		let start = null;
		const step = timestamp => {
			start = start || timestamp;
			const progress = timestamp - start,
				time = Math.min(1, (timestamp - start) / duration);

			window.scrollTo(0, initY - timingFunc(time) * initY);
			if (progress < duration) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}

	clear() {
		this.subject.next();
	}
	
}
